import React, { useState, useEffect } from 'react';
import BotonMapaProceso from './BotonMapaProceso';
import DisenoDesarrolloForm from './DisenoDesarrolloForm';
import DisenoDesarrolloDetalle from './DisenoDesarrolloDetalle';
import { subirDatos, eliminarDato } from './syncSupabase';

const ESTADOS = {
  borrador: { label: 'Borrador', color: '#6B6FD6', bg: '#E8E9F6' },
  en_proceso: { label: 'En proceso', color: '#d97706', bg: '#fef3c7' },
  listo_cliente: { label: 'Listo para cliente', color: '#2A7FFF', bg: '#dbeafe' },
  aprobado: { label: 'Aprobado', color: '#16a34a', bg: '#dcfce7' },
  rechazado: { label: 'Con cambios', color: '#dc2626', bg: '#fee2e2' },
};

export default function DisenoDesarrollo({ onVolver, oscuro, usuario }) {
  const [proyectos, setProyectos] = useState([]);
  const [filtro, setFiltro] = useState('todos');
  const [showForm, setShowForm] = useState(false);
  const [seleccionado, setSeleccionado] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem('dd_proyectos');
    if (data) setProyectos(JSON.parse(data));
  }, []);

  const guardar = (lista) => {
    setProyectos(lista);
    localStorage.setItem('dd_proyectos', JSON.stringify(lista));
    subirDatos('dd_proyectos');
  };

  const agregarProyecto = (nuevo) => {
    const lista = [{ ...nuevo, id: Date.now(), version: 1, historial: [], fechaCreacion: new Date().toLocaleDateString('es-AR') }, ...proyectos];
    guardar(lista);
    setShowForm(false);
  };

  const actualizarProyecto = (actualizado) => {
    const lista = proyectos.map(p => p.id === actualizado.id ? actualizado : p);
    guardar(lista);
    setSeleccionado(actualizado);
  };

  const eliminarProyecto = async (id) => {
    if (!window.confirm('¿Eliminar este proyecto de Diseño y Desarrollo?')) return;
    const lista = proyectos.filter(p => p.id !== id);
    setProyectos(lista);
    localStorage.setItem('dd_proyectos', JSON.stringify(lista));
    await eliminarDato('dd_proyectos', id);
    if (seleccionado?.id === id) setSeleccionado(null);
  };

  const proyectosFiltrados = filtro === 'todos' ? proyectos : proyectos.filter(p => p.estado === filtro);

  const conteo = (estado) => proyectos.filter(p => p.estado === estado).length;

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif', background: '#E8E9F6', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button onClick={onVolver} style={{ background:"none", border:"1px solid #E5E7EB", borderRadius:"8px", padding:"6px 12px", fontSize:"12px", cursor:"pointer", color:"#6B7280", marginRight:"8px" }}>← Menú</button><span style={{ fontSize:"22px" }}>✏️</span>
            <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>Diseño y Desarrollo</h1>
            <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1C3FAA', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>ISO 9001 §8.3</span>
          </div>
          <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px', marginLeft: '32px' }}>
            Gestión de proyectos gráficos · Aprobación de artes
          </p>
        </div>
        <button
          onClick={() => setShowForm(true)}
          style={{ background: '#1C3FAA', color: 'white', border: 'none', borderRadius: '10px', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
        >
          + Nuevo proyecto
        </button>
        {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="diseno_desarrollo" oscuro={oscuro} />}
      </div>

      {/* Métricas */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
        {[
          { label: 'Total', valor: proyectos.length, color: '#1C3FAA', bg: '#E8E9F6' },
          { label: 'Esperando cliente', valor: conteo('listo_cliente'), color: '#2A7FFF', bg: '#dbeafe' },
          { label: 'Aprobados', valor: conteo('aprobado'), color: '#16a34a', bg: '#dcfce7' },
          { label: 'Con cambios', valor: conteo('rechazado'), color: '#dc2626', bg: '#fee2e2' },
        ].map((m, i) => (
          <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '14px 16px', border: '1px solid #E5E7EB' }}>
            <div style={{ fontSize: '11px', color: '#6B7280', marginBottom: '4px' }}>{m.label}</div>
            <div style={{ fontSize: '26px', fontWeight: '700', color: m.color }}>{m.valor}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '4px', marginBottom: '14px', background: 'white', padding: '4px', borderRadius: '10px', border: '1px solid #E5E7EB', width: 'fit-content' }}>
        {[
          { key: 'todos', label: 'Todos' },
          { key: 'en_proceso', label: 'En proceso' },
          { key: 'listo_cliente', label: 'Esperando cliente' },
          { key: 'aprobado', label: 'Aprobados' },
          { key: 'rechazado', label: 'Con cambios' },
        ].map(t => (
          <button key={t.key} onClick={() => setFiltro(t.key)}
            style={{ padding: '6px 14px', borderRadius: '8px', border: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer', background: filtro === t.key ? '#1C3FAA' : 'transparent', color: filtro === t.key ? 'white' : '#6B7280' }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Layout principal */}
      <div style={{ display: 'grid', gridTemplateColumns: seleccionado ? '1fr 420px' : '1fr', gap: '14px' }}>

        {/* Tabla */}
        <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
          {proyectosFiltrados.length === 0 ? (
            <div style={{ padding: '60px', textAlign: 'center', color: '#9CA3AF' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>✏️</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>Sin proyectos</div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>Creá el primer proyecto con el botón de arriba</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Proyecto', 'Cliente', 'Origen', 'Versión', 'Diseñador', 'Estado', 'Aprobación'].map(h => (
                    <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {proyectosFiltrados.map(p => {
                  const est = ESTADOS[p.estado] || ESTADOS.borrador;
                  return (
                    <tr key={p.id} onClick={() => setSeleccionado(p)}
                      style={{ cursor: 'pointer', background: seleccionado?.id === p.id ? '#EFF6FF' : 'white' }}
                      onMouseEnter={e => { if (seleccionado?.id !== p.id) e.currentTarget.style.background = '#F9FAFB'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = seleccionado?.id === p.id ? '#EFF6FF' : 'white'; }}>
                      <td style={{ padding: '12px 14px', borderBottom: '1px solid #F3F4F6' }}>
                        <div style={{ fontWeight: '600', fontSize: '13px', color: '#111827' }}>{p.nombre}</div>
                        <div style={{ fontSize: '11px', color: '#9CA3AF' }}>DyD-{p.id}</div>
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{p.cliente || '—'}</td>
                      <td style={{ padding: '12px 14px', borderBottom: '1px solid #F3F4F6' }}>
                        {p.ot ? <span style={{ background: '#dbeafe', color: '#1d4ed8', fontSize: '11px', padding: '2px 7px', borderRadius: '6px', fontWeight: '600' }}>OT-{p.ot}</span>
                          : <span style={{ background: '#F3F4F6', color: '#6B7280', fontSize: '11px', padding: '2px 7px', borderRadius: '6px' }}>Interno</span>}
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: '12px', color: '#6B7280', borderBottom: '1px solid #F3F4F6' }}>v{p.version}</td>
                      <td style={{ padding: '12px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{p.disenador || '—'}</td>
                      <td style={{ padding: '12px 14px', borderBottom: '1px solid #F3F4F6' }}>
                        <span style={{ background: est.bg, color: est.color, fontSize: '11px', padding: '3px 9px', borderRadius: '20px', fontWeight: '600' }}>{est.label}</span>
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: '11px', color: '#6B7280', borderBottom: '1px solid #F3F4F6' }}>
                        {p.estado === 'aprobado' ? '✅ Aprobado' : p.estado === 'listo_cliente' ? '⏳ Pendiente' : p.estado === 'rechazado' ? '🔄 Revisión' : '—'}
                      </td>
                      <td style={{ padding: '12px 14px', borderBottom: '1px solid #F3F4F6' }} onClick={e => e.stopPropagation()}>
                        <button onClick={() => eliminarProyecto(p.id)} style={{ background: 'none', border: '1px solid #fee2e2', color: '#dc2626', borderRadius: '6px', padding: '3px 8px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}>🗑</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* Panel detalle */}
        {seleccionado && (
          <DisenoDesarrolloDetalle
            proyecto={seleccionado}
            onActualizar={actualizarProyecto}
            onCerrar={() => setSeleccionado(null)}
          />
        )}
      </div>

      {/* Modal form */}
      {showForm && (
        <DisenoDesarrolloForm
          onGuardar={agregarProyecto}
          onCancelar={() => setShowForm(false)}
        />
      )}
    </div>
  );
}
